// extracted by mini-css-extract-plugin
export default {"root":"KU67Uur0","collapsed":"y_uRZXtA","blockquote":"m3sD7_cn","gradientContainer":"JNVT2DU9","collapseIcon":"pyX4NpPB","clickable":"RmvXwV0W"};